import React from "react";
import { Box, IconButton, Link, TableCell, TableRow, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  garmentMiddleSection: {
    display: "flex",
    gap: "5px",
  },
  qtySection: {
    display: "flex",
    alignItems: "center",
  },
}));

const MobileCartItem = ({ item, handleEditOrder, handleRemoveItem, isRemoveBtn }) => {
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell sx={{ padding: "16px 0" }}>
        <img src={item.image} style={{ maxHeight: "75px", maxWidth: "75px" }} />
      </TableCell>
      <TableCell style={{ width: "100%" }}>
        <div className={classes.garmentMiddleSection}>
          <span>
            <Typography variant="body2">{item.productTitle}</Typography>
            {item.customizedItem && <Typography variant="body1">{item.variantTitle}</Typography>}
            <span className={classes.qtySection}>
              {isRemoveBtn && (
                <IconButton onClick={handleRemoveItem}>
                  <DeleteForeverOutlinedIcon />
                </IconButton>
              )}
              <Typography sx={{ padding: "8px 8px 0 8px" }} variant="body2">
                Qty: {item.quantity}
              </Typography>
            </span>
          </span>
          {item.customizedItem && (
            <span>
              <IconButton href={item.previewUrl} target="_blank">
                <VisibilityOutlinedIcon />
              </IconButton>
            </span>
          )}
        </div>
      </TableCell>
      <TableCell padding="none" align="right">
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <span style={{ paddingTop: "21px" }}>
            {item.customizedItem && (
              <Link onClick={handleEditOrder} sx={{ color: "#249DD7" }}>
                Edit
              </Link>
            )}
          </span>
          <span>
            <Typography variant="body2">${item.price.toFixed(2)}</Typography>
          </span>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default MobileCartItem;
